import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastComponent } from './toast/toast.component';
import { MessageService } from './message.service';
;
import { ToastPositionEnum } from '@gp-angular/shared/schema';
import { ToastContainerDirective, ToastrModule, ToastrService } from 'ngx-toastr';

@NgModule({
	declarations: [
		ToastComponent
	],
	imports: [
		CommonModule,

    ToastContainerDirective,
		ToastrModule.forRoot({
			timeOut: 5000,
			positionClass: ToastPositionEnum.SMALL_BOTTOM,
			preventDuplicates: true
		})
	],
	providers: [
		MessageService,
		ToastrService,
	]
})
export class ServiceMessageModule {
	static forRoot(): ModuleWithProviders<ServiceMessageModule> {
		return {
			ngModule: ServiceMessageModule,
			providers: [MessageService, ToastrService]
		};
	}
}
